<div class="search-filter-container">
  <form (ngSubmit)="onSearch()" [formGroup]="searchFgroup">
    <ng-template [ngIf]="isFromHome">
      <div class="home-search-box">
        <div class="input-outline">
          <div class="search-btn" (click)="showSearchDialog()">
            <i class="icon-search"></i>
            <h1 class="truncateText">{{'search.outlet' | translate}}</h1>
          </div>
          <div class="filter-btn" (click)="onClickDisplayFilterDropdown()">
            <i class="icon-filter-alt"></i>
          </div>
          <div class="filter-badge" *ngIf="totalCountItem && totalCountItem > 1">{{totalCountItem}}</div>
        </div>
      </div>
    </ng-template>

    <ng-template [ngIf]="!isFromHome">
      <div class="input-outline">
        <i class="icon-search"></i>
        <span class="p-float-label">
          <input type="text" id="searchInputText" pInputText formControlName="searchInputText" name="searchInputText"
            autocomplete="off" #searchValue />
          <label for="searchInputText">{{'label.search' | translate}}</label>
        </span>
        <i class="icon-times" *ngIf="searchValue.value.length > 0" (click)="clearSearchField()"></i>
      </div>
    </ng-template>
  </form>
</div>

<p-dialog *ngIf="displayFilterDropdown" [(visible)]="displayFilterDropdown" [modal]="true" [dismissableMask]="true"
  [blockScroll]="true" styleClass="fullScreen-dialog displayFilterDropdown-dialog">

  <div class="displayFilterDropdown-header">
    <app-mobile-header [title]="'label.filter'" [manualBackEvent]="true"
      (onManualBackEvent)="displayFilterDropdown = false"></app-mobile-header>
    <i class="icon-delete" (click)="clearAllFilter()"></i>
  </div>

  <div class="displayFilterDropdown-container">
    <div class="catgAttrsList_2-container" *ngIf="catgAttrsDes_1"
      [style.border-bottom]="priceRangeValues || rateList || catgAttrsDes_2 ? '0.5px solid var(--neutral-20)' : 'none'">
      <h1 class="filterTitle">{{catgAttrsDes_1}}</h1>
      <p-selectButton [options]="catgAttrsList_1" [(ngModel)]="catgAttrsValue_1" optionLabel="attrOptionDesc"
        (click)="onClickItem()" [multiple]="true">
      </p-selectButton>
    </div>

    <div class="priceRange-container" *ngIf="priceRangeValues"
      [style.border-bottom]="rateList || catgAttrsDes_2 ? '0.5px solid var(--neutral-20)' : 'none'">
      <h1 class="filterTitle">{{'label.price' | translate}}</h1>
      <div class="selected-priceRange" [ngClass]="{'rangeText-active': priceRangeActive}">
        <span>{{selectedChannel.currency.currPrefix}} {{priceRangeValues[0]}}</span>
        <span>{{selectedChannel.currency.currPrefix}} {{priceRangeValues[1]}}<span
            *ngIf="priceRangeValues && priceRangeValues[1] == selectedChannel.filterMaxVal">+</span>
        </span>
      </div>
      <div class="price-slider">
        <p-slider [(ngModel)]="priceRangeValues" [range]="true" (onChange)="priceSlide(priceRangeValues)"
          class="price-range" [ngClass]="{'price-range-active': priceRangeActive}">
        </p-slider>
      </div>
    </div>

    <div class="rating-container" *ngIf="rateList"
      [style.border-bottom]="catgAttrsDes_2 ? '0.5px solid var(--neutral-20)' : 'none' ">
      <h1 class="filterTitle">{{'label.ratings' | translate}}</h1>
      <div class="rating-content">
        <div *ngFor="let itm of rateList">
          <app-button [textButton]="true" [iconName]="'icon-rate-star'" [buttonName]="itm" [borderButton]="true"
            (onClickEvent)="onClickRate(itm)" class="rate-btn"
            [ngClass]="{'selectedRate': selectedRateValue == itm} "></app-button>
        </div>
      </div>
    </div>

    <div class="catgAttrsList_2-container" *ngIf="catgAttrsDes_2">
      <h1 class="filterTitle">{{catgAttrsDes_2}}</h1>
      <p-selectButton [options]="catgAttrsList_2" [(ngModel)]="catgAttrsValue_2" optionLabel="attrOptionDesc"
        (click)="onClickItem()" [multiple]="true">
      </p-selectButton>
    </div>


    <app-bottom-action-footer
      [buttonName]="'button.apply.with value' | translate : {value: totalCountItem > 0 ? '(' + totalCountItem + ')' : ''}"
      [disbaleButton]="totalCountItem == 0" (click)="onClickFilterBtn()"></app-bottom-action-footer>
  </div>
</p-dialog>